import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { GiTakeMyMoney } from "react-icons/gi";
import MultiStep from "react-multistep";
import { useLocation } from "react-router-dom";
import { instance } from "../../config/config";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import noImg from "../../assets/img/no-img.jpg";
import { FaEdit } from "react-icons/fa";
import { CiCircleMore } from "react-icons/ci";

const ModelTrainingState = ({ state, message }) => {
  const location = useLocation();
  const [listings, setListings] = useState([])
  const [response, setResponse] = useState({
    state: null,
    message: "",
  });
  const [feature, setFeature] = useState({});

  console.log("@state", location)
  useEffect(() => {
    if (location !== null) {
      setFeature(location?.state?.feature);
      setResponse({
        state: location?.state?.state,
        message: location?.state?.message,
      });
      setListings(location?.state?.message?.listings)
    }
  }, [location]);

  const responseSteps = [
    "Calculating Transit Score",
    "Calculating Walk Score",
    "Calculating Bike Score",
    "Calculating Crime Score",
    "Calculating Grocery Score",
    "Calculating Recreation Score",
    "Calculating Education Score",
    "Calculating Emergency Score",
    "Please wait while we provide you with the predicted rent.",
  ];

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentStep < responseSteps.length - 1) {
        return setCurrentStep((prevStep) => prevStep + 1);
      } else {
        clearInterval(interval);
      }
    }, 5000); // Show each step for 5 seconds

    // Clear the interval after 40 seconds
    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 35000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [currentStep, responseSteps.length]);

  const progress = ((currentStep + 1) / responseSteps.length) * 100;

  const BasicInfo = () => (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <input
          className={"form-control"}
          placeholder="Property Type"
          name="listingPropertyType"
          value={"Property Type: " + feature?.listingPropertyType || ""}
          disabled={true}
        />
        <input
          className={"mx-2 form-control"}
          placeholder="Bedroom"
          name="bedroomCount"
          value={"Bedroom: " + feature?.bedroomCount || ""}
          disabled={true}
        />
        <input
          className={"form-control"}
          placeholder="Baths"
          name="bathroomCount"
          value={"Bath: " + feature?.bathroomCount || ""}
          disabled={true}
        />
      </div>
      <div>
        <div className="my-4 custom-border d-flex justify-content-between">
          <input
            className={"form-control"}
            placeholder="Address"
            name="listingAddress"
            value={"Address: " + feature?.listingAddress || ""}
            disabled={true}
          />
        </div>
        <input
          className="form-control w-50"
          placeholder="Listing Sq ft"
          name="listingSizeSquareFeet"
          value={"Sq Ft: " + feature?.listingSizeSquareFeet || ""}
          disabled={true}
        />
      </div>
    </div>
  );

  const allUtilities = [
    "heatUtility",
    "waterUtility",
    "hydroUtility",
    "furnishedUtility",
  ];
  const Utilities = () => (
    <div className="d-flex justify-content-center align-items-center flex-wrap">
      {allUtilities?.map((util, idx) => {
        return (
          <div class="form-check form-check-inline" key={idx}>
            <input
              class="form-check-input"
              type="checkbox"
              id={idx}
              value={util}
              name={util}
              checked={feature && feature[util] === 1}
              disabled
            />
            <label class="form-check-label text-capitalize fs-8" for={idx}>
              {util?.split("Utility")[0]}
            </label>
          </div>
        );
      })}
    </div>
  );
  const allPolicies = ["petPolicy", "smokingPolicy"];

  const Policy = () => (
    <>
      {" "}
      <div className="d-flex justify-content-center align-items-center flex-wrap">
        {allPolicies?.map((util, idx) => {
          return (
            <div class="form-check form-check-inline" key={idx}>
              <input
                class="form-check-input"
                type="checkbox"
                id={idx}
                value={util}
                name={util}
                checked={feature && feature[util] === 1}
                disabled
              />
              <label class="form-check-label text-capitalize fs-8" for={idx}>
                {util?.split("Policy")[0]}
              </label>
            </div>
          );
        })}
      </div>
    </>
  );
  const allAmenities = [
    "gymAmenity",
    "parkingAmenity",
    "acAmenity",
    "applianceAmenity",
    "storageAmenity",
  ];
  const Amenity = () => (
    <>
      <div className="d-flex justify-content-center align-items-center flex-wrap">
        {allAmenities?.map((util, idx) => {
          return (
            <div class="form-check form-check-inline" key={idx}>
              <input
                class="form-check-input"
                type="checkbox"
                id={idx}
                value={util}
                name={util}
                checked={feature && feature[util] === 1}
                disabled
              />
              <label class="form-check-label text-capitalize fs-8" for={idx}>
                {util?.split("Amenity")[0]}
              </label>
            </div>
          );
        })}
      </div>
    </>
  );

  const steps = [
    {
      title: "Basic Info",
      component: BasicInfo(),
    },
    {
      title: "Utilities",
      component: Utilities(),
    },
    {
      title: "Policy",
      component: Policy(),
    },
    {
      title: "Amenities",
      component: Amenity(),
    },
  ];

  return (
    <>
      <div className="w-100 bg-white mx-auto vh-70 my-5">
        {state ? (
          <div className="d-flex flex-column justify-content-center align-items-center pt-5 mt-5">
            <div className="d-flex flex-column justify-content-center align-items-center">
              {/* {progress} */}
              <div className="progress" style={{ width: `100%` }}>
                <div
                  className="progress-bar progress-bar-striped bg-success progress-bar-animated"
                  role="progressbar"
                  aria-valuenow={`${progress}`}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>

              <p className="mt-3 fs-9">{responseSteps[currentStep]}</p>
            </div>
          </div>
        ) : (
          <div>
            {response?.message?.message !== "" && (
              <>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <GiTakeMyMoney fontSize={100} />

                  <p className="fs-30 text-center pt-2 ">
                    The predicted rent is:{" "}
                    <span className="text-primary-color">
                      ${response?.message?.predictedRent}
                    </span>
                  </p>
                </div>
                <div className="shadow px-4 w-50 mx-auto mt-4">
                  <MultiStep
                    activeStep={0}
                    showNavigation={true}
                    steps={steps}
                    prevButton={{
                      title: "Back",
                      style: {
                        background: "transparent",
                        border: "1px solid #586bd6",
                        color: "#586bd6",
                        padding: ".2em 1.2em",
                      },
                    }}
                    nextButton={
                      // Conditionally render next button based on current step
                      {
                        title: "Next",
                        style: {
                          background: "transparent",
                          border: "1px solid #586bd6",
                          color: "#586bd6",
                          padding: ".2em 1.2em",
                          margin: "2em 1em",
                        },
                      }
                    }
                  />
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <div>
        <Recommendations listings={listings}/>
      </div>
    </>
  );
};

const Recommendations = ({listings}) => {
  // console.log(listings)
  // const [listings, setListings] = useState([]);

  // useEffect(() => {
  //   instance
  //     .get("api/listings")
  //     .then((res) => {
  //       setListings(res?.data?.slice(0, 10));
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  const navigate = useNavigate();

  const handleRedirect = (item) => {
    navigate(`/properties/${item?.id}`, { state: item?.id });
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  return (
    <div className="container p-4">
      <>
      {
        listings!==undefined &&
        <>
        <h5 className="text-center">Recommendations</h5>

        <Carousel
          swipeable={true}
          draggable={true}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={false}
          // autoPlay={this.props.deviceType !== "mobile" ? true : false}
          autoPlaySpeed={2000}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={["tablet", "mobile"]}
          // deviceType={this.props.deviceType}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {
            listings?.length>0?
          listings?.map((item, key) => {
            return (
              <div class="property card shadow border-0 mx-4">
                <img
                  src={
                    item?.imageLink?.match(/\.(jpeg|jpg|gif|png)$/) !== null
                      ? item?.imageLink
                      : noImg
                  }
                  class="recommendationImage w-100"
                  alt={item?.listingAddress}
                />
                <div
                  className="tags position-absolute end-0 pe-3"
                  style={{ bottom: "22%" }}
                >
                  <span className="bg-primary-color rounded-pill p-1 px-3 fs-8">
                    {item.listingPropertyType}
                  </span>
                </div>
                <div class="card-body">
                  <p className="text-secondary-color fw-bold mb-1">
                    ${item?.listingRent}
                  </p>
                  <p className="mb-0 fs-8 text-secondary fw-bold">
                    {item?.listingAddress}
                  </p>
                </div>
                <div class="overlay">
                  <div className="w-50 mx-auto text-center">
                    <p
                      className="px-2 py-2 bg-primary-color  ms-2 fs-9 mb-3"
                      onClick={() => handleRedirect(item)}
                    >
                      <CiCircleMore className="me-2" />
                      Show More
                    </p>

                    <p
                      className="text-center w-75 mx-auto py-2 bg-white text-primary-color fs-9"
                      onClick={() =>
                        navigate(`/listings/${item?.id}/edit`, {
                          state: item?.id,
                        })
                      }
                    >
                      <FaEdit className="me-2" />
                      Edit
                    </p>
                  </div>
                </div>
              </div>
            );
          })
          :
          <p className="fs-9">Sorry, there are no recommended listings.</p>
        }
        </Carousel>
        </>
}
      </>
    </div>
  );
};
export default ModelTrainingState;
